<div class="top">
    <div class="header">
        <h1 align="center">Blog</h1>
    </div>
    <div class="vc_empty_space" style="height: 30px;"><span class="vc_empty_space_inner"></span>
    </div>
    <div class="header1">
        <article id="post-6435"
            class="post-6435 post type-post status-publish format-standard hentry category-shop-ship-from-india tag-buydesibedesi tag-kanjeevaram tag-personalshopper tag-saree tag-shiptoaustralia tag-shiptoeurope tag-shiptouk tag-shiptousa tag-shipworldwide tag-shopfromindia">
            <div class="qodef-post-content">
                <div class="qodef-post-text">
                    <div class="qodef-post-text-inner clearfix">
                        <div class="qodef-post-link-holder">
                            <div class="qodef-post-link-holder-inner">
                                <h2 style="margin-bottom: 20px;">
                                    To Sis, With Love
                                </h2>
                            </div>
                        </div>
                        <div class="qodef-post-single-content">
                            <h2>Looking to send a gift to your sister in India or abroad ?</h2>
                            <p>This Raksha Bandhan, gift the finest pure silk <b>Kanjeevaram sarees</b>, banarasi
                                sarees, or any sarees, lehengas, dresses, ethnic handbags, branded watches, ethnic
                                shoes, jewelry to the SISTER you love. Send #yourLoveCart today.</p>
                            <p>Buy anything from India and get it delivered to your doorstep anywhere in the world.</p>
                            <!-- <a itemprop="url" href="https://yourdesicart.com/order-now/" target="_self"
                                class="qodef-btn qodef-btn-medium qodef-btn-solid">
                                <span class="qodef-btn-text">Order Now</span>
                                <span class="qodef-btn-icon-normal"><i class="qodef-icon-font-awesome fa  "></i></span>
                                <span class="qodef-btn-icon-flip"><i class="qodef-icon-font-awesome fa  "></i></span>

                            </a> -->
                            <p>&nbsp;</p>

                            <div class="wp-block-columns">
                                <div class="wp-block-column">
                                    <a><img src="http://yourdesicart.com/wp-content/uploads/2020/06/yourDesiCart.png"
                                            alt="" data-id="6453"
                                            data-full-url="http://yourdesicart.com/wp-content/uploads/2020/06/yourDesiCart.png"
                                            data-link="http://yourdesicart.com/to-sis-with-love/yourdesicart-2/"
                                            class="wp-image-6453"
                                            srcset="http://yourdesicart.com/wp-content/uploads/2020/06/yourDesiCart.png 591w, http://yourdesicart.com/wp-content/uploads/2020/06/yourDesiCart-177x300.png 177w"
                                            sizes="(max-width: 400px) 100vw, 400px"></a>



                                    <a><img src="http://yourdesicart.com/wp-content/uploads/2020/06/5-1.png" alt=""
                                            data-id="6452"
                                            data-full-url="http://yourdesicart.com/wp-content/uploads/2020/06/5-1.png"
                                            data-link="http://yourdesicart.com/to-sis-with-love/5-1/"
                                            class="wp-image-6452"
                                            srcset="http://yourdesicart.com/wp-content/uploads/2020/06/5-1.png 591w, http://yourdesicart.com/wp-content/uploads/2020/06/5-1-177x300.png 177w"
                                            sizes="(max-width: 400px) 100vw, 400px"></a>


                                    <a><img src="http://yourdesicart.com/wp-content/uploads/2020/06/4-1.png" alt=""
                                            data-id="6451"
                                            data-full-url="http://yourdesicart.com/wp-content/uploads/2020/06/4-1.png"
                                            data-link="http://yourdesicart.com/to-sis-with-love/4-1/"
                                            class="wp-image-6451"
                                            srcset="http://yourdesicart.com/wp-content/uploads/2020/06/4-1.png 591w, http://yourdesicart.com/wp-content/uploads/2020/06/4-1-177x300.png 177w"
                                            sizes="(max-width: 400px) 100vw, 400px"></a>


                                </div>
                                <div class="wp-block-column">
                                    <a><img src="http://yourdesicart.com/wp-content/uploads/2020/06/3-1.png" alt=""
                                            data-id="6450"
                                            data-full-url="http://yourdesicart.com/wp-content/uploads/2020/06/3-1.png"
                                            data-link="http://yourdesicart.com/to-sis-with-love/3-1/"
                                            class="wp-image-6450"
                                            srcset="http://yourdesicart.com/wp-content/uploads/2020/06/3-1.png 591w, http://yourdesicart.com/wp-content/uploads/2020/06/3-1-177x300.png 177w"
                                            sizes="(max-width: 400px) 100vw, 400px"></a>

                                    <a><img src="http://yourdesicart.com/wp-content/uploads/2020/06/2-1.png" alt=""
                                            data-id="6449"
                                            data-full-url="http://yourdesicart.com/wp-content/uploads/2020/06/2-1.png"
                                            data-link="http://yourdesicart.com/to-sis-with-love/2-1/"
                                            class="wp-image-6449"
                                            srcset="http://yourdesicart.com/wp-content/uploads/2020/06/2-1.png 591w, http://yourdesicart.com/wp-content/uploads/2020/06/2-1-177x300.png 177w"
                                            sizes="(max-width: 400px) 100vw, 400px"></a>

                                    <a><img src="http://yourdesicart.com/wp-content/uploads/2020/06/1-1.png" alt=""
                                            data-id="6448"
                                            data-full-url="http://yourdesicart.com/wp-content/uploads/2020/06/1-1.png"
                                            data-link="http://yourdesicart.com/to-sis-with-love/1-1/"
                                            class="wp-image-6448"
                                            srcset="http://yourdesicart.com/wp-content/uploads/2020/06/1-1.png 591w, http://yourdesicart.com/wp-content/uploads/2020/06/1-1-177x300.png 177w"
                                            sizes="(max-width: 400px) 100vw, 400px"></a>


                                </div>

                            </div>

                            <p></p>
                        </div>
                        <div class="qodef-post-info qodef-section-bottom clearfix">
                            <!-- <div class="qodef-section-bottom-left">
                                <div class="qodef-single-tags-holder">
                                    <h6 class="qodef-single-tags-title">Tags:</h6>
                                    <div class="qodef-tags">
                                        <a href="http://yourdesicart.com/tag/buydesibedesi/"
                                            rel="tag">BuyDesiBeDesi</a>, <a
                                            href="http://yourdesicart.com/tag/kanjeevaram/" rel="tag">Kanjeevaram</a>,
                                        <a href="http://yourdesicart.com/tag/personalshopper/"
                                            rel="tag">PersonalShopper</a>, <a href="http://yourdesicart.com/tag/saree/"
                                            rel="tag">Saree</a>, <a href="http://yourdesicart.com/tag/shiptoaustralia/"
                                            rel="tag">ShipToAustralia</a>, <a
                                            href="http://yourdesicart.com/tag/shiptoeurope/" rel="tag">ShipToEurope</a>,
                                        <a href="http://yourdesicart.com/tag/shiptouk/" rel="tag">ShipToUK</a>, <a
                                            href="http://yourdesicart.com/tag/shiptousa/" rel="tag">ShipToUSA</a>, <a
                                            href="http://yourdesicart.com/tag/shipworldwide/"
                                            rel="tag">ShipWorldwide</a>, <a
                                            href="http://yourdesicart.com/tag/shopfromindia/"
                                            rel="tag">ShopFromIndia</a> </div>
                                </div>
                            </div> -->
                            <!-- <div class="qodef-section-bottom-right">
                                <div class="qodef-blog-share">
                                    <div class="qodef-social-share-holder qodef-list normal qodef-social-col-4">
                                        <ul class="clearfix">
                                            <li class="qodef-facebook-share">
                                                <a class="qodef-share-link" href="#"
                                                    onclick="window.open('http://www.facebook.com/sharer.php?s=100&amp;p[title]=To+Sis%2C+With+Love&amp;p[url]=http%3A%2F%2Fyourdesicart.com%2Fto-sis-with-love%2F&amp;p[images][0]=&amp;p[summary]=Looking+to+send+a+gift+to+your+sister+in+India+or+abroad+%3F+This+Raksha+Bandhan%2C+gift+the+finest+pure+silk+Kanjeevaram+sarees%2C+banarasi+sarees%2C+or+any+sarees%2C+lehengas%2C+dresses%2C+ethnic+handbags%2C+branded+watches%2C+ethnic+shoes%2C+jewelry+to+the+SISTER+you+love.+Send+%23yourLoveCart+today....', 'sharer', 'toolbar=0,status=0,width=620,height=280');">
                                                    <span class="qodef-social-network-icon social_facebook"></span>
                                                </a>
                                            </li>
                                            <li class="qodef-twitter-share">
                                                <a class="qodef-share-link" href="#"
                                                    onclick="window.open('http://twitter.com/home?status=Looking+to+send+a+gift+to+your+sister+in+India+or+abroad+%3F+This+Raksha+Bandhan%2C+gift+the+finest+pure+silk+Kanjeevaram+http://yourdesicart.com/to-sis-with-love/', 'popupwindow', 'scrollbars=yes,width=800,height=400');">
                                                    <span class="qodef-social-network-icon social_twitter"></span>
                                                </a>
                                            </li>
                                            <li class="qodef-linkedin-share">
                                                <a class="qodef-share-link" href="#"
                                                    onclick="popUp=window.open('http://linkedin.com/shareArticle?mini=true&amp;url=http%3A%2F%2Fyourdesicart.com%2Fto-sis-with-love%2F&amp;title=To+Sis%2C+With+Love', 'popupwindow', 'scrollbars=yes,width=800,height=400');popUp.focus();return false;">
                                                    <span class="qodef-social-network-icon social_linkedin"></span>
                                                </a>
                                            </li>
                                            <li class="qodef-pinterest-share">
                                                <a class="qodef-share-link" href="#"
                                                    onclick="popUp=window.open('http://pinterest.com/pin/create/button/?url=http%3A%2F%2Fyourdesicart.com%2Fto-sis-with-love%2F&amp;description=To Sis, With Love&amp;media=', 'popupwindow', 'scrollbars=yes,width=800,height=400');popUp.focus();return false;">
                                                    <span class="qodef-social-network-icon social_pinterest"></span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="qodef-post-info-below clearfix">
            </div>
        </article>
    </div>

    <footer>
        <div class="row col-xs-12 col-sm-12 col-md-12" id="footer">
            <div class="col-xs-12 col-sm-4">
                <div id="cvvv">
                    <h4 class="title">yourDesiCart</h4>
                    <div class="textwidget">
                        <div class="vc_empty_space" style="height: 12px"><span class="vc_empty_space_inner"></span>
                        </div>


                        <p>84 High street, Kondapur Hyderabad 500084</p>
                        <p>Email: yourDesiCart@gmail.com</p>
                        <p>Phone: +91 8328579397</p>
                        <div class="vc_empty_space" style="height: 32px"><span class="vc_empty_space_inner"></span>
                        </div>
                        <span style="margin: 0px 5px 0px 0px">
                            <a itemprop="url" class="" href="https://www.facebook.com/yourDesiCart" target="_blank"
                                rel="noopener noreferrer">
                                <span class="flip-icon-holder">
                                    <span class="icon-normal"><i
                                            class="qodef-icon-font-awesome fa fa-facebook qodef-icon-element"
                                            style="color:#ffff;font-size:22px"
                                            onMouseOver="this.style.color='rgb(0, 211, 243)'"
                                            onMouseOut="this.style.color='#ffffff'"></i></span>
                                </span>
                            </a>
                        </span>
                        <span style="margin: 0px 5px 0px 5px">
                            <a itemprop="url" class="" href="https://twitter.com/" target="_blank"
                                rel="noopener noreferrer">
                                <span class="flip-icon-holder">
                                    <span class="icon-normal"><i
                                            class="qodef-icon-font-awesome fa fa-twitter qodef-icon-element"
                                            style="color:#ffff;font-size:22px"
                                            onMouseOver="this.style.color='rgb(0, 211, 243)'"
                                            onMouseOut="this.style.color='#ffffff'"></i></span>
                                </span>
                            </a>
                        </span>
                        <span style="margin: 0px 5px 0px 5px">
                            <a itemprop="url" class="" href="https://www.linkedin.com/" target="_blank"
                                rel="noopener noreferrer">
                                <span class="flip-icon-holder">
                                    <span class="icon-normal"><i
                                            class="qodef-icon-font-awesome fa fa-linkedin qodef-icon-element"
                                            style="color:#ffff;font-size:22px"
                                            onMouseOver="this.style.color='rgb(0, 211, 243)'"
                                            onMouseOut="this.style.color='#ffffff'"></i></span>
                                </span>
                            </a>
                        </span>
                        <span style="margin: 0px 5px 0px 5px">
                            <a itemprop="url" class="" href="https://www.instagram.com/yourDesiCart" target="_blank"
                                rel="noopener noreferrer">
                                <span class="flip-icon-holder">
                                    <span class="icon-normal"><i
                                            class="qodef-icon-font-awesome fa fa-instagram qodef-icon-element"
                                            style="color:#ffff;font-size:22px"
                                            onMouseOver="this.style.color='rgb(0, 211, 243)'"
                                            onMouseOut="this.style.color='#ffffff'"></i></span>
                                </span>
                            </a>
                        </span>
                        <span style="margin: 0px 5px 0px 5px">
                            <a itemprop="url" class="" href="https://in.pinterest.com/yourDesiCart/" target="_blank"
                                rel="noopener noreferrer">
                                <span class="flip-icon-holder">
                                    <span class="icon-normal"><i
                                            class="qodef-icon-font-awesome fa fa-pinterest qodef-icon-element"
                                            style="color:#ffff;font-size:22px"
                                            onMouseOver="this.style.color='rgb(0, 211, 243)'"
                                            onMouseOut="this.style.color='#ffffff'"></i></span>
                                </span>
                            </a>
                        </span>
                        <span style="margin: 0px 5px 0px 5px">
                            <a itemprop="url" class="" href="https://www.youtube.com" target="_blank"
                                rel="noopener noreferrer">
                                <span class="flip-icon-holder">
                                    <span class="icon-normal"><i
                                            class="qodef-icon-font-awesome fa fa-youtube-play qodef-icon-element"
                                            style="color:#ffff;font-size:22px"
                                            onMouseOver="this.style.color='rgb(0, 211, 243)'"
                                            onMouseOut="this.style.color='#ffffff'"></i></span>
                                </span>
                            </a>
                        </span>
                    </div>
                </div>
            </div>
            <!-- <div class="vertical-line" style="height: 200px;width:0.1px; color: silver"></div>
                        <div class="col-xs-12 col-sm-3">
                            <div class="qodef-column" style="margin-top: 40px;margin-left: 15px;">
            
                                <div class="textwidget custom-html-widget"><a href="terms-of-use">Terms of
                                        Use</a></div>
            
                                <div id="custom_html-3" class="widget_text widget qodef-footer-column-2 widget_custom_html">
                                    <div class="textwidget custom-html-widget"><a href="prohibited-items">Prohibited
                                            Items</a></div>
                                </div>
                            </div>
                        </div> -->
            <div class="vertical-line" style="height: 200px;"></div>
            <div class="col-xs-12 col-sm-4">

                <div id="cvvv">
                    <h4 class="title" style="margin-left: 15px;">Quick Links</h4>
                    <ul>
                        <li>
                            <a [routerLink]="[]" (click)="personal()">Personal
                                Shopper from India</a>
                        </li>
                        <li>
                            <a [routerLink]="[]" (click)="onamshopping()">Onam
                                Shopping from India</a>
                        </li>
                        <li>
                            <a [routerLink]="[]" (click)="tosis()">To Sis, With
                                Love</a>
                        </li>
                        <li>
                            <a [routerLink]="[]" (click)="provibited()">Prohibited
                                Items</a>
                        </li>


                        <li>
                            <a [routerLink]="[]" (click)="terms()">Terms of
                                Use</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="vertical-line" style="height: 200px;"></div>
            <div class="col-xs-12 col-sm-3">
                <div id="cvvv">
                    <h4 class="title" style="margin-left: 15px;">ContactUs</h4>
                    <ul>
                        <li>
                            <a [routerLink]="[]" (click)="contactUs()">ContactUs</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</div>